
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { ACTION_CLEAR_DATA, getConnectedAccount, getNetworkInfoById, getNetworks } from '../../../../../actions/addFeedActions';
import { baseUrl, CalendlyPop, getInitialRoute, TOAST_DISMISS, TOAST_LOADING } from '../../../../../utils';
import CreateFeed from './CreateFeed'
import { closePricingModal } from '../../../../../utils/close_modal';
import { GET_FEEDS } from '../../../../../actions/manageFeedsAction';
import { togglePlanSection } from '../../../../../actions/show_modal_Action';
import { togglePhotoBoothUpgrade, togglePlanSection_D } from '../../../../../actions/showDisplayModalAction';
import { Button, Modal } from 'react-bootstrap';
import { ADD_FEED_NETWORKS } from '../../../../../reducers/keys';
import { getFontVariants } from '../../../../../actions/appsMoreAction';
import LoadingScreen from '../../../../CommonComponents/LoadingScreen';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';
import withRouter from '../../../../CommonComponents/WithRouter';
import { HUBSPOT_URL, WASABI_PATH } from '../../../../../actions/api';
import CustomPost from '../../AppsMore/modals/Custom-Post';

const doesFeedExist = (feedList, networkId) => {
    const feeds = feedList.filter(feed => feed.networkId == networkId);
    return feeds.length > 0;
}
class AllFeeds extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalShow: false,
            create: false,
            selectedNetwork: null,
            feedInfo: null,
            isLimitExceed: false,
            planId: [],
            loading: false,
            manageFeedData: [],
            showPopUp: false,
            customUpload: false,
            isPremium: false
        }
    }

    componentWillMount() {
        getNetworks().then(response => {
            const { data } = response;
            if (data && Object.keys(data).length > 0) {
                this.setState({ isLimitExceed: data.feedLimitExceeded }, () => {
                    this.props.updateNetworkDetails({ ...data, networks: data.networks });
                })
            }
        });
        this.props.getManageFeedsData(responsedata => {
            if (responsedata && responsedata.length > 0) {
                this.setState({ manageFeedData: responsedata });
            }
        });
    }



    backToInitialPage = () => {
        this.setState({ selectedNetwork: null });
    }

    componentDidMount() {
        const { authorized } = this.props;
        const planIds = authorized.userData?.UserPlan?.planId || "";
        const planId = planIds.length > 1 ? planIds.split(",") : [planIds]
        this.setState({ planId: planId })
        window.$(document).on('click', '#addFeed', this.backToInitialPage);
    }

    onNetworkSelect = (network) => {
        const { authorized, togglePhotoBoothUpgrade, navigate } = this.props;
        const { UserRule, user } = authorized?.userData || {};
        const newNetworkFlag = user?.bluesky_threads ?? true;
        const photo_booth_upload = UserRule?.photo_booth_upload;

        if (network.networkId == 30) {
            if (photo_booth_upload) navigate(`/wall/photobooth/${localStorage.getItem('wallId')}`)
            else togglePhotoBoothUpgrade(true)
        } else if (network.networkId == 34) this.setState({ customUpload: true })
        else if ([33].includes(network.networkId) || ([31, 32].includes(network.networkId) && !newNetworkFlag) || ([4].includes(network.networkId) && !UserRule?.allow_googlereview)) {
            this.setState({ showPopUp: true });
        } else {
            this.setState({ loading: true });
            if (!this.state.loading) {
                TOAST_LOADING();
                this.props.ACTION_CLEAR_DATA();
                getNetworkInfoById(network.networkId).then(res => {
                    const { responseData } = res.data;

                    // Fetch connected accounts for current network + related accounts
                    const linkedAccountMap = { 18: 2, 28: 27 };
                    this.props.FETCH_CONNECTED_ACCOUNTS(network.networkId);
                    if (linkedAccountMap[network.networkId]) {
                        this.props.FETCH_CONNECTED_ACCOUNTS(linkedAccountMap[network.networkId]);
                    }

                    // Handle SnapUp navigation separately
                    if (network.networkId == 29) {
                        this.props.getFontVariants();
                        this.openSnapUp();
                    }

                    this.setState({ feedInfo: responseData });

                    setTimeout(() => {
                        this.setState({ selectedNetwork: network, loading: false }, () => {
                            const { isLimitExceed, manageFeedData } = this.state;
                            const isFeedExist = doesFeedExist(manageFeedData, network.networkId);
                            const freeNetworks = [10, 15, 28, 29];
                            const limitedFreeNetworks = [10, 15, 28];

                            const shouldShowModal =
                                network.isPremium ||
                                (isLimitExceed && !freeNetworks.includes(network.networkId)) ||
                                (isLimitExceed && limitedFreeNetworks.includes(network.networkId) && !isFeedExist);

                            if (shouldShowModal) this.clickToToggleModal();
                            this.setState({ isPremium: network.isPremium })
                        });
                    }, 700);

                    TOAST_DISMISS();
                }).catch(err => {
                    this.setState({ loading: false });
                    console.log("err", err);
                    TOAST_DISMISS();
                })
            }
        }
    }

    clickToToggleModal = () => {
        this.setState({ modalShow: true, selectedNetwork: null }, () => {
            document.getElementById('createFeedOption').setAttribute("style", `display:none`);
        })
    }

    clickToShowModal = () => {
        this.setState({ modalShow: false, selectedNetwork: null }, () => {
            document.getElementById('createFeedOption').setAttribute("style", `display:true`);
        })
    }


    openSnapUp = () => {
        this.props.closeModal();
        this.props.navigate(`/wall/snapup/${localStorage.getItem('wallId')}`)
    }

    render() {
        const { addFeedData, hideAddfeed, ACTION_CLEAR_DATA, wallData } = this.props
        const { selectedNetwork, feedInfo, isLimitExceed, modalShow, planId, showPopUp, customUpload, isPremium } = this.state;

        return (
            <>
                <div className="add-feed-modal" id="createFeedOption">

                    {addFeedData ?
                        <div className="add-feed-modal-inner">
                            {<div className="f-between border-bottom page_custom_header overflow-hidden">
                                <div className="d-flex align-items-center flex-nowrap">
                                    <Button variant='link' onClick={() => selectedNetwork ? this.setState({ selectedNetwork: null }, () => ACTION_CLEAR_DATA()) : this.props.closeModal()} className="me-3 border-end border-0 p-3 rounded-0">
                                        <FontAwesomeIcon icon={'chevron-left'} iconClass={'p-0'} />
                                    </Button>
                                    <h5 className="m-0 text-nowrap overflow-hidden" id="exampleModalLongTitle">{selectedNetwork ? isLimitExceed && [10, 15, 28].includes(selectedNetwork.networkId) ? "Upgrade" : `Create ${selectedNetwork.networkName} Feed` : 'Pick a source'}</h5>
                                </div>
                                <div className="close_btn">
                                    <Button variant='link' type="button" className="p-3" onClick={() => this.props.closeModal()}>
                                        <FontAwesomeIcon type={'solid'} icon={'xmark'} />
                                    </Button>
                                </div>
                            </div>}

                            {!selectedNetwork ? Object.keys(addFeedData).length <= 0 ? <LoadingScreen /> : <div className="add-feed-modal-body">
                                <div className="container">
                                    <div className="small_container">
                                        <div className="p-3">
                                            <div className="my-3">
                                                <h3 className="network_title_wt">{addFeedData?.resposneMessage ? addFeedData?.resposneMessage : addFeedData?.responseMessage}</h3>
                                                <p>Select the social platform from which you want to add the feeds</p>
                                                <ul className="networks">
                                                    {addFeedData && addFeedData.networks && addFeedData.networks.map(network => (
                                                        <li className={network.networkCode} key={network.networkId} onClick={() => this.onNetworkSelect(network)}>
                                                            <button type="button" className="add_feed_modal position-relative">
                                                                {network.isPremium && (
                                                                    <img src={`${WASABI_PATH}react-app/media/icons/social-icons-square/premium.svg`} alt="Premium" className="position-absolute" style={{ top: -1, right: 10, width: 14, height: 20 }} />
                                                                )}
                                                                <img src={baseUrl(`square-icons/${network.networkCode == "twitter" ? `${network.networkCode}X` : network.networkCode}.svg?v=90`)} alt={network.networkName} height={50} width={50} className="img-fluid" />
                                                                <span>{network.networkName}</span>
                                                                {/* {[4, 30, 31, 32].includes(network.networkId) ? <small className='new-tag position-absolute'>New</small> : null} */}
                                                            </button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> : selectedNetwork.networkId !== 29 ? <CreateFeed isLimitExceed={isLimitExceed} network={selectedNetwork} onBack={() => this.setState({ selectedNetwork: null })} hideAddfeed={hideAddfeed} feedInfo={feedInfo} addFeedData={addFeedData} showUpgradePop={this.clickToToggleModal} createdFeeds={this.state.manageFeedData} /> : null}
                        </div> : ""}
                </div>
                <CalendlyPop show={showPopUp} hidePop={() => this.setState({ showPopUp: false })} url={HUBSPOT_URL} />
                <Modal
                    size="lg"
                    dialogClassName=" modal-dialog-centered modal-dialog"
                    show={modalShow ? modalShow : (isLimitExceed && selectedNetwork && ![10, 15, 28, 29].includes(selectedNetwork.networkId))}
                    onHide={() => this.clickToShowModal()}>
                    <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
                    <Modal.Body>
                        <div className="row py-5">
                            <div className="col-lg-12">
                                <div className="upgredeMain text-center">
                                    <div className="Errorimage pb-3"><img src={baseUrl(`error/add-social-feed.png`)} className="img-fluid" width={500} height={300} /></div>
                                    <div className="permissionMsg my-4 px-4">
                                        <h4 className="ErrorMsg"> {isPremium ? 'This is a Premium Network 🔒' : 'Add More Social Feeds'} </h4>
                                        <p className="msgSec">{isPremium ? 'Upgrade your plan to add feeds from this source.' : 'Oops! Looks like you have reached your feed limit. Now add more feeds without upgrading your entire plan and curate exciting widgets with diverse content.'}</p>
                                    </div>
                                    <div className="buttonUpgred mb-3">
                                        <Button variant='primary' id="addonFeaturesScroll" onClick={this.props.pricingModal_D} className="commanBtn px-5" data-factors-click-bind="true">
                                            Upgrade Now
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                {customUpload ? <CustomPost showcustomPost={customUpload} getData={wallData} closecustomPost={() => this.setState({ customUpload: false })} /> : null}
            </>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        wallData: state.appsMore,
        authorized: state.authenticated,
        addFeedData: state.moderation.addFeedNetworks ? state.moderation.addFeedNetworks : []
    }
}

const mapDispatchToProps = dispatch => {
    return {
        FETCH_CONNECTED_ACCOUNTS: (id) => dispatch(getConnectedAccount(id)),
        ACTION_CLEAR_DATA: () => dispatch(ACTION_CLEAR_DATA()),
        updateNetworkDetails: (data) => dispatch({ type: ADD_FEED_NETWORKS, payload: data }),
        closeModal: () => closePricingModal(dispatch),
        pricingModal: () => dispatch(togglePlanSection(true)),
        pricingModal_D: () => dispatch(togglePlanSection_D(true)),
        getManageFeedsData: (callback) => dispatch(GET_FEEDS(callback)),
        getFontVariants: () => dispatch(getFontVariants()),
        togglePhotoBoothUpgrade: () => dispatch(togglePhotoBoothUpgrade(true))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AllFeeds));